import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import logo_pop from '../assets/images/logo-pop.png';
import ProfileHeader from '../components/ProfileHeader';
import EDSFooter from '../components/EDSFooter';
import ApiService from '../services/ApiService';
import NotificationService from '../services/NotificationService';

const Login_zmien_haslo = () => {
    // const apiService = ApiService.getInstance();
    const apiService = new ApiService();
    const notificationService = NotificationService.getInstance();

    const history = useHistory();

    const [formData, setFromData] = useState({
        oldPassword: '',
        password: '',
        repeatedPassword: '',
    });

    const save = (e) => {
        e.preventDefault();

        const proceed = () => {
            const payload = {
                password: formData.oldPassword,
                newpassword: formData.password,
            };

            apiService.apiPost('UserResetPassword', payload, (response) => {
                if (response.success) {
                    // if (typeof response.data.succeeded === 'boolean' && response.data.succeeded) {

                    // force user to login after changing password
                    apiService.logout(false);
                    history.push('/login_haslo_zmienione');

                    // } else {
                    // }
                } else {
                    if (response.data.message == 'Błędne hasło.') {
                        notificationService.showError('Błędne hasło');
                    } else {
                        notificationService.showError();
                    }
                }
            });
        };

        if (typeof formData.oldPassword === 'string' && formData.oldPassword.length > 0) {
            if (typeof formData.password === 'string' && formData.password.length > 0) {
                if (
                    typeof formData.repeatedPassword === 'string' &&
                    formData.repeatedPassword.length > 0
                ) {
                    if (formData.password === formData.repeatedPassword) {
                        proceed();
                    } else {
                        notificationService.showError('Wpisane hasła nie pasują do siebie');
                    }
                } else {
                    notificationService.showError('Nie wpisano powtórzonego hasła');
                }
            } else {
                notificationService.showError('Nie wpisano hasła');
            }
        } else {
            notificationService.showError('Nie wpisano starego hasła');
        }
    };

    return (
        <>
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>
                <div className="header__caption-box">
                    <span className="header__caption">Proces zakupu kursu</span>
                </div>
            </header>
            <div className="content">
                <ProfileHeader></ProfileHeader>
                <div className="half-half">
                    <main>
                        <section className="margin-top-64">
                            <h2 className="h2">Zmień hasło logowania</h2>
                            <p className="margin-top-16">Podaj stare i ustal nowe hasło.</p>
                            {/* <p className="margin-top-16">Hasło powinno składać się z...</p> */}
                            <form
                                id="reset-password"
                                className="reset-password"
                                method="post"
                                action=""
                                onSubmit={(e) => save(e)}
                            >
                                <div className="form__row margin-top-32">
                                    <label htmlFor="password" className="form__label">
                                        Stare Hasło<sup> *</sup>
                                    </label>
                                    <input
                                        type="password"
                                        name="password"
                                        id="password"
                                        className="form__input"
                                        title="Stare hasło"
                                        onChange={(e) =>
                                            setFromData({
                                                ...formData,
                                                ...{ oldPassword: e.target.value },
                                            })
                                        }
                                        required
                                    />
                                </div>
                                <div className="form__row margin-top-32">
                                    <label htmlFor="repassword" className="form__label">
                                        Nowe hasło<sup> *</sup>
                                    </label>
                                    <input
                                        type="password"
                                        name="repassword"
                                        id="repassword"
                                        className="form__input"
                                        title="Nowe hasło"
                                        onChange={(e) =>
                                            setFromData({
                                                ...formData,
                                                ...{ password: e.target.value },
                                            })
                                        }
                                        required
                                    />
                                </div>
                                <div className="form__row margin-top-32">
                                    <label htmlFor="repassword" className="form__label">
                                        Potwierdź Nowe hasło<sup> *</sup>
                                    </label>
                                    <input
                                        type="password"
                                        name="repassword"
                                        id="repassword"
                                        className="form__input"
                                        title="Potwierdź Nowe hasło"
                                        onChange={(e) =>
                                            setFromData({
                                                ...formData,
                                                ...{ repeatedPassword: e.target.value },
                                            })
                                        }
                                        required
                                    />
                                </div>
                                <input
                                    type="submit"
                                    className="btn-primary margin-top-32 margin-bottom-32"
                                    value="Zatwierdź"
                                />
                            </form>
                        </section>
                    </main>
                    <div className="decorative">
                        <svg
                            width="320"
                            height="320"
                            viewBox="0 0 320 320"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M106.76 31.8C87.7119 37.0497 68.7931 42.758 50.0201 48.92C48.3059 49.4753 46.7821 50.5009 45.6223 51.8799C44.4625 53.2589 43.7133 54.936 43.4601 56.72C32.3801 139.86 57.9801 200.52 88.5201 240.48C101.45 257.568 116.868 272.622 134.26 285.14C141.18 290.02 147.3 293.54 152.12 295.8C154.52 296.94 156.48 297.7 157.98 298.16C158.636 298.39 159.312 298.558 160 298.66C160.68 298.55 161.349 298.382 162 298.16C163.52 297.7 165.48 296.94 167.88 295.8C172.68 293.54 178.82 290 185.74 285.14C203.132 272.621 218.55 257.568 231.48 240.48C262.02 200.54 287.62 139.86 276.54 56.72C276.289 54.9351 275.541 53.257 274.381 51.8776C273.221 50.4982 271.696 49.4732 269.98 48.92C256.96 44.66 234.98 37.72 213.24 31.82C191.04 25.8 170.62 21.34 160 21.34C149.4 21.34 128.96 25.8 106.76 31.82V31.8ZM101.44 11.2C123.14 5.3 146.2 0 160 0C173.8 0 196.86 5.3 218.56 11.2C240.76 17.2 263.14 24.3 276.3 28.6C281.802 30.417 286.68 33.7493 290.374 38.214C294.067 42.6787 296.426 48.0948 297.18 53.84C309.1 143.38 281.44 209.74 247.88 253.64C233.649 272.42 216.68 288.957 197.54 302.7C190.922 307.456 183.91 311.637 176.58 315.2C170.98 317.84 164.96 320 160 320C155.04 320 149.04 317.84 143.42 315.2C136.09 311.638 129.078 307.456 122.46 302.7C103.321 288.957 86.3518 272.419 72.1201 253.64C38.5601 209.74 10.9001 143.38 22.8201 53.84C23.5739 48.0948 25.933 42.6787 29.6264 38.214C33.3199 33.7493 38.1979 30.417 43.7001 28.6C62.8039 22.3362 82.0562 16.5345 101.44 11.2Z" />
                            <path d="M190 129.999C190.003 136.205 188.081 142.26 184.499 147.329C180.917 152.397 175.852 156.23 170 158.299L177.7 198.099C177.98 199.547 177.937 201.038 177.573 202.467C177.209 203.896 176.534 205.227 175.595 206.364C174.657 207.501 173.478 208.417 172.145 209.045C170.811 209.674 169.354 209.999 167.88 209.999H152.12C150.647 209.996 149.193 209.668 147.862 209.039C146.531 208.409 145.355 207.493 144.419 206.356C143.482 205.219 142.809 203.89 142.446 202.462C142.083 201.035 142.04 199.545 142.32 198.099L150 158.299C144.815 156.466 140.234 153.243 136.757 148.982C133.28 144.722 131.041 139.587 130.285 134.14C129.529 128.693 130.284 123.143 132.469 118.096C134.654 113.05 138.184 108.7 142.673 105.524C147.162 102.348 152.438 100.467 157.925 100.087C163.411 99.7061 168.896 100.841 173.781 103.367C178.665 105.893 182.762 109.713 185.622 114.41C188.483 119.107 189.997 124.5 190 129.999Z" />
                        </svg>
                    </div>
                </div>
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};
export default Login_zmien_haslo;
